export default __webpack_public_path__ + "static/media/LogoHC.9579b5d7.png";